import { render, staticRenderFns } from "./SelectPermission.vue?vue&type=template&id=795f5e88&scoped=true&"
import script from "./SelectPermission.vue?vue&type=script&lang=js&"
export * from "./SelectPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f5e88",
  null
  
)

export default component.exports